import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractHttp} from '../../../../../../core/classes/abstract-http';
import {environment} from '../../../../../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class SmsService {

    private _smsTemplates = null;

    constructor(private http: HttpClient) {
        // tslint:disable-next-line:max-line-length
        // const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.SMSSend}`;
        // super(http, url);
    }

    sendSms(params): Observable<any> {
        const url = `${environment.ENTORNO}${environment.SessionService.General}${environment.SessionService.ENDPOINT.SMSSend}`;
        return this.http.post<any>(url, params);
    }

    getComboTypeSms(): Observable<any> {
        return new Observable<any>(subscriber => {
            if (this._smsTemplates) {
                subscriber.next(this._smsTemplates);
                subscriber.complete();
            } else {
                this.http.post<any>(`${environment.ENTORNO}${environment.SessionService.PANELCONTROL.GESTION_SMS.urlComboTypeSms}`, {}).subscribe(result => {
                    this._smsTemplates = result;
                    subscriber.next(this._smsTemplates);
                    subscriber.complete();
                });
            }
        });
    }
}
